export const TYPE_DOCTOR    = 1
export const TYPE_USER      = 2
export const TYPE_LAWYER    = 3
export const TYPE_MODERATOR = 4
export const TYPE_LEADER    = 5